import { MessageBox } from 'element-ui';

export async function alert(message, title, options) {
  if (!options) {
    options = {};
  }

  options = {
    confirmButtonText: '확인',
    showClose: false,
    customClass: 'fifl-message-box',
    confirmButtonClass: 'gray',
    cancelButtonClass: 'white',
    closeOnPressEscape: false,
    closeOnClickModal: false,
    ...options
  };

  return await MessageBox.alert(message, title, options);
}

export async function confirm(message, title, options) {
  if (!options) {
    options = {};
  }

  options = {
    confirmButtonText: '확인',
    cancelButtonText: '취소',
    showClose: false,
    customClass: 'fifl-message-box',
    confirmButtonClass: 'gray',
    cancelButtonClass: 'white',
    closeOnPressEscape: false,
    closeOnClickModal: false,
    ...options
  };

  return await MessageBox.confirm(message, title, options);
}
